import React, {KeyboardEventHandler} from 'react';
import {FieldValueProps} from '../field/FieldValue';
import {WidgetStyles} from '../types/WidgetStyles';
import {AutoComplete, widgetProps} from '../widgets/common';
import {
  TextInputStyles,
  TextInputWidget,
  TextOutputWidget,
} from '../widgets/TextWidget';
import {useAntennaProps} from './hooks/useAntennaProps';
import {useOnChange} from './hooks/useOnChange';
import {useTextProps} from './hooks/useTextProps';
import {dummyResourceDetails, ResourceDetails} from '../types/ResourceDetails';
import {useOnPressAction} from './hooks/useOnPressAction';

export type Props = FieldValueProps & {
  item?: ResourceDetails;
  multiline: boolean;
  autoComplete?: AutoComplete;
  onKeyUp?: KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

export function TextField(props: Props): JSX.Element | null {
  const onChange = useOnChange(props.onChange, props.field.id);
  const textProps = useTextProps(props.field, props.multiline);
  const antennaProps = useAntennaProps(props.field);
  const styles = widgetProps<WidgetStyles | undefined>(
    props.field,
    'styles',
    undefined,
  );

  const inputStyles = widgetProps<TextInputStyles | undefined>(
    props.field,
    'input_styles',
    undefined,
  );

  const onPress = useOnPressAction(
    props.field,
    props.schema,
    props.item ?? dummyResourceDetails(),
    props.actions,
  );

  if (props.readOnly) {
    return (
      <TextOutputWidget
        {...textProps}
        value={props.value}
        styles={props.styles || styles}
        onPress={onPress}
      />
    );
  }

  return (
    <TextInputWidget
      {...props}
      {...textProps}
      {...antennaProps}
      onChange={onChange}
      styles={inputStyles}
    />
  );
}
